import { useState, useEffect, useCallback } from "react"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import Project_Setting from "./Project_Setting"
import SellIcon from "@mui/icons-material/Sell"
import { useNavigate } from "react-router"
import { useGlobalContext } from "../../../Context/GlobalContext"
import CreatableSelect from "react-select/creatable"
import Search from "@mui/icons-material/Search"
import SearchStaff from "../../../components/Staff/SearchStaff"
import Cookies from "js-cookie"

function debounce(func, delay) {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func(...args), delay)
  }
}

const Add_Project = () => {
  const {
    baseUrl,
    openToast,
    searchedClient,
    setSearchedClient,
    searchClient,
    searchedStaff,
    setSearchedStaff,
    searchStaff,
  } = useGlobalContext()
  const [projectDescription, setProjectDescription] = useState()
  const navigate = useNavigate()
  const [editorData, setEditorData] = useState("")
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ script: "sub" }, { script: "super" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"], // Remove formatting button
    ],
  }
  const [isLoading, setIsLoading] = useState(false)
  const formats = [
    "header",
    "font",
    "list",
    "bullet",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "script",
    "align",
    "link",
    "image",
    "video",
  ]

  const [formData, setformData] = useState({
    estimatedHours: "",
    projectName: "",
    customer: "",
    calculateProgress: false,
    priority: "",
    billingType: "",
    status: "",
    totalRate: "",
    startDate: "",
    deadline: "",
    members: "",
    tags: "",
    description: "",
    sendEmail: false,
  })

  function handleCloseForm() {
    navigate("/projects")
  }
  const [clientData, setClientData] = useState([])

  const handleChange = (selectedOptions) => {
    // Extract only the value from each selected option
    const tagValues = selectedOptions.map((option) => option.value)
    setformData((prevFormData) => ({ ...prevFormData, tags: tagValues }))
    setSelectedTag(tagValues)
  }

  const fetchDetail = async () => {
    const result = await fetch(baseUrl + "client", {
      headers: {
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
    })
    if (result.status == 200) {
      const res = await result.json()
      console.log(res)
      setClientData(res.data)
    } else {
      openToast("An Error Occured", "error")
      // alert("An Error Occured")
    }
  }

  useEffect(() => {
    console.log(clientData)
  }, [])

  useEffect(() => {
    fetchDetail()
    fetchRoles()
  }, [])

  const [staffDetail, setStaffDetail] = useState()
  const fetchRoles = async () => {
    const result = await fetch(baseUrl + "staff", {
      headers: {
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
    })
    if (result.status == 200) {
      const res = await result.json()
      setStaffDetail(res.data)
    } else {
      // openToast("An Error Occured")
    }
  }
  const [tags, setTags] = useState([
    { value: "thumbnail", label: "thumbnail" },
    { value: "youtube", label: "youtube" },
    { value: "youtube thumbnail", label: "youtube thumbnail" },
    { value: "carousel", label: "carousel" },
    { value: "RE-DESIGN", label: "REDESIGN" },
    { value: "Ads", label: "Ads" },
    { value: "drdcrcrc", label: "drdcrcrc" },
  ])
  const [selectedTag, setSelectedTag] = useState([])
  const [projectName, setProjectName] = useState()
  const [billingType, setBillingType] = useState()
  const [rate, setRate] = useState()
  const [hours, setHours] = useState()
  const [date, setDate] = useState()
  const [deadline, setDeadLine] = useState()
  const [selectedClient, setSelectClient] = useState()
  const [selectedStaff, setSelectedStaff] = useState()
  console.log(selectedClient)
  const [sendEmail, setSendEmail] = useState(false)
  const [members, setMembers] = useState([])
  console.log(members)

  const [selectedStatus, setSelectedStatus] = useState("")
  const [fetchProjectStatus, setFetchProjectStatus] = useState([])
  const [fetchProjectPriority, setFetchProjectPriority] = useState([])
  async function fetchProjectDetails() {
    try {
      const result = await fetch(baseUrl + "project-status", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      const data = await result.json()
      setFetchProjectStatus(data.data)
    } catch (error) {
      openToast(error.message, "error")
    }
  }
  async function fetchProjectPriorityDetails() {
    try {
      const result = await fetch(baseUrl + "project-priority", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      const data = await result.json()
      setFetchProjectPriority(data.data)
    } catch (error) {
      openToast(error.message, "error")
    }
  }

  useEffect(() => {
    fetchProjectDetails()
    fetchProjectPriorityDetails()
  }, [])

  const [inputValue, setInputValue] = useState("")
  console.log(inputValue)
  const [searchMembers, setSearchMembers] = useState("")

  const debouncedSearchClient = useCallback(
    debounce((query) => {
      searchClient(query)
    }, 300),
    [],
  )

  const handleInputChange = (e) => {
    const value = e.target.value
    setInputValue(value)

    if (value === "") {
      setSearchedClient(null)
    } else {
      searchClient(value)
    }
  }
  const handleSearchStaff = (e) => {
    const value = e.target.value
    setSearchMembers(value)

    if (value === "") {
      setSearchedStaff(null) // Clear state immediately
    } else {
      searchStaff(value, setIsLoading) // Debounce for other cases
    }
  }

  async function projectSubmit(e) {
    e.preventDefault()
    const plainTextDescription = (editorData || "").replace(/<\/?p>/g, "")
    console.log(selectedClient)
    const projectNameString = fetchProjectStatus.length > 0 ? fetchProjectStatus[0].project_name : "" // Option 1, or use Option 2 as needed
    try {
      setIsLoading(true)
      const result = await fetch(baseUrl + "project/create", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          project_name: formData.projectName,
          customerId: formData.customer,
          status: formData.status,
          billing_type: formData.billingType,
          priority: formData.priority,
          total_rate: formData.totalRate,
          estimated_hours: formData.estimatedHours,
          staffId: formData.members,
          start_date: formData.startDate,
          deadline: formData.deadline,
          description: plainTextDescription,
          send_mail: formData.sendEmail,
          tags: formData.tags,
          description: formData.description,
        }),
      })
      console.log(result)
      const data = await result.json()
      if (result.status == 201) {
        openToast(data.msg || "Add Project Successfully", "success")
        navigate("/Projects")
      } else {
        console.log(data.msg)
        openToast(data.msg || "error occured", "error")
      }
    } catch (error) {
      console.log("error", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    setformData((prev) => ({ ...prev, members: members }))
  }, [members])

  return (
    <div className="mx-auto max-w-[100%] md:max-w-[80%] add-project-form">
      <Tabs className="shadow-cs m-[20px] md:mt-[30px] md:mr-0 md:mb-0 md:ml-[0px] rounded-lg">
        <div className="">{/* <Link to = "/clients"><FaArrowLeft /></Link> */}</div>
        <TabList className="flex gap-4 border-[#B1B1B1] p-[14px] border-b font-medium text-[16px] cursor-pointer">
          <Tab className="hover:border-[#27004a] py-2 hover:border-b-1 font-medium text-md">Project</Tab>
          {/* <Tab className="hover:border-[#27004a] py-2 hover:border-b-1 font-medium text-[16px] text-gray-600">
            Project Settings
          </Tab> */}
        </TabList>

        <TabPanel className="m-5">
          <form action="" onSubmit={projectSubmit}>
            <div className="space-y-5 w-[100%]">
              <div className="space-y-2">
                <label className="font-medium text-gray-700 text-sm">* Project Name</label>
                <input
                  className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                  type="text"
                  value={formData.projectName}
                  onChange={(e) => {
                    setProjectName(e.target.value)
                    setformData({ ...formData, projectName: e.target.value })
                  }}
                  name="projectname"
                  required
                />
              </div>

              <div className="relative space-y-2 w-full billing-type-project">
                <label className="font-medium text-gray-700 text-sm">* Customer</label>

                <div className="relative">
                  <input
                    className="border-[#DBDCDE] px-2 border rounded-md w-[100%] h-[35px]"
                    type="text"
                    name="members"
                    placeholder="Search Client"
                    value={inputValue}
                    onChange={handleInputChange}
                  />

                  {searchedClient && (
                    <div className="top-[35px] left-0 z-10 absolute bg-gray-100 border rounded-md w-full max-h-36 overflow-y-scroll">
                      {searchedClient.length === 0 ? (
                        <p className="p-2 text-center">No client found</p>
                      ) : (
                        <ul>
                          {searchedClient.map((client) => (
                            <li
                              key={client?.clientDetails?.id}
                              className={`p-2 hover:bg-gray-200 cursor-pointer ${
                                selectedClient?.clientDetails?.id === client?.clientDetails?.id
                                  ? "bg-green-500 text-white hover:bg-green-500"
                                  : ""
                              }`}
                              onClick={() => {
                                setformData((prev) => ({
                                  ...prev,
                                  customer: client?.clientDetails?.id,
                                }))
                                setSelectClient(client)
                                setInputValue(client.name)
                                setSearchedClient(null)
                              }}
                            >
                              {client.name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
                <Search className="top-[30px] right-[10px] absolute" />

                {selectedClient && (
                  <div className="mt-2">
                    <span className="inline-flex items-center bg-green-100 px-2.5 py-0.5 rounded-full font-medium text-green-800 text-xs">
                      {selectedClient.name}
                      <button
                        type="button"
                        className="inline-flex ml-1 text-green-400 focus:outline-none"
                        onClick={() => {
                          setSelectClient(null)
                          setInputValue("")
                          setformData((prev) => ({ ...prev, customer: "" }))
                        }}
                      >
                        <span className="sr-only">Remove</span>
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            fillRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </span>
                  </div>
                )}
              </div>

              <div className="flex items-center gap-3 font-medium">
                <input type="checkbox" name="progress" required />
                <label htmlFor="progress" className="font-medium text-[13px] progress-through">
                  Calculate progress through tasks
                </label>
              </div>

              <div className="space-y-2">
                <h1 className="font-medium text-gray-700 text-sm">Progress 0%</h1>
                <div className="border-[#D9D9D9] bg-[#27004a] border rounded-md h-[6px]"></div>
              </div>

              <div className="flex gap-10 billing-form-type w-[100%]">
                <div className="space-y-2 w-[50%] billing-type-project">
                  <label className="font-medium text-gray-700 text-sm">* Billing Type</label>
                  <select
                    value={formData.billingType}
                    onChange={(e) => {
                      setBillingType(e.target.value)
                      setformData({ ...formData, billingType: e.target.value })
                    }}
                    className="border-[#DBDCDE] bg-white pl-[4px] border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                    name="billingType"
                    required
                  >
                    <option value="Fixed Rate">Fixed rate</option>
                    <option value="Project Hours">Project Hours</option>
                    <option value="Task Hours Based on task hourly rate">Task Hours Based on task hourly rate</option>
                  </select>
                </div>

                <div className="space-y-2 w-[50%] billing-type-project">
                  <label className="font-medium text-gray-700 text-sm">Status</label>
                  <select
                    className="border-[#DBDCDE] bg-white pl-[4px] border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                    name="status"
                    required
                    value={formData.status}
                    onChange={(e) => {
                      console.log(e.target.value)
                      setSelectedStatus(e.target.value)
                      setformData({ ...formData, status: e.target.value })
                    }}
                  >
                    <option value="">Select a status</option>
                    {fetchProjectStatus?.map((s) => {
                      return <option value={s?.id}>{s?.project_name}</option>
                    })}
                  </select>
                </div>
              </div>
              <div className="space-y-2 billing-type-project">
                <label className="font-medium text-gray-700 text-sm">* Project Priority</label>
                <select
                  className="border-[#DBDCDE] bg-white pl-[4px] border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                  name="priority"
                  required
                  value={formData.priority}
                  onChange={(e) => {
                    console.log(e.target.value)
                    setformData({ ...formData, priority: e.target.value })
                  }}
                >
                  <option value="">Select a status</option>
                  {fetchProjectPriority?.map((s) => {
                    return <option value={s?.id}>{s?.Priority_name}</option>
                  })}
                </select>
              </div>
              <div className="flex gap-10 billing-form-type w-[100%]">
                <div className="space-y-2 w-[50%] billing-type-project">
                  <label className="font-medium text-gray-700 text-sm">Total Rate</label>
                  <input
                    name="totalRate"
                    className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                    type="number"
                    value={formData.totalRate}
                    onChange={(e) => {
                      setRate(Number.parseInt(e.target.value) || 0)
                      setformData({ ...formData, totalRate: e.target.value })
                    }}
                    required
                  />
                </div>
                <div className="space-y-2 w-[50%] billing-type-project">
                  <label className="font-medium text-gray-700 text-sm">Estimated Hours</label>
                  <input
                    className="border-[#DBDCDE] pl-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                    type="number"
                    name="estimatedHours"
                    value={formData.estimatedHours}
                    onChange={(e) => {
                      setHours(Number.parseInt(e.target.value) || 0)
                      setformData({ ...formData, estimatedHours: e.target.value })
                    }}
                    required
                  />
                </div>
              </div>

              <div className="">
                <div className="mt-2">
                  <SearchStaff members={members} setMembers={setMembers} />
                </div>

                <div className="flex gap-10 billing-form-type mt-[14px] w-[100%]">
                  <div className="space-y-2 w-[50%] billing-type-project">
                    <label className="font-medium text-gray-700 text-sm">* Start Date</label>
                    <input
                      className="border-[#DBDCDE] px-2 border rounded-md w-[100%] h-[35px] focus-visible:outline-none"
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={(e) => {
                        setDate(e.target.value)
                        setformData({ ...formData, startDate: e.target.value })
                      }}
                      required
                    />
                  </div>

                  <div className="space-y-2 w-[50%] billing-type-project">
                    <label className="font-medium text-gray-700 text-sm">Deadline</label>
                    <input
                      className="border-[#DBDCDE] px-2 border rounded-md w-[100%] h-[35px]"
                      type="date"
                      name="deadline"
                      value={formData.deadline}
                      onChange={(e) => {
                        setDeadLine(e.target.value)
                        setformData({ ...formData, deadline: e.target.value })
                      }}
                      required
                    />
                  </div>
                </div>

                <div className="mt-[20px]">
                  <label className="font-medium text-[#000000ba] text-[13px] xl:text-[14px]">Task Description</label>
                  <br />
                  <textarea
                    type="text"
                    onChange={(e) => {
                      setProjectDescription(e.target.value)
                      setformData({ ...formData, description: e.target.value })
                    }}
                    className="border-1 mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
                    required
                  />{" "}
                  <br />
                </div>
              </div>

              <div className="flex items-center gap-[10px]">
                <SellIcon />
                {/* <span className="pl-2 font-medium">Tags</span> */}
                <CreatableSelect
                  isMulti
                  options={tags}
                  onChange={handleChange}
                  placeholder="Select or add tags..."
                  className="w-full tag-selector"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: "35px",
                      border: "1px solid #d1d5db",
                    }),
                    multiValue: (provided) => ({
                      ...provided,
                      backgroundColor: "#e5e7eb",
                      borderRadius: "4px",
                    }),
                    multiValueLabel: (provided) => ({
                      ...provided,
                      fontSize: "0.875rem",
                    }),
                    multiValueRemove: (provided) => ({
                      ...provided,
                      color: "#4b5563",
                      cursor: "pointer",
                    }),
                  }}
                  required
                />
              </div>

              <div className="space-x-3 border-[#B1B1B1] py-4 border-t border-b">
                <input
                  type="checkbox"
                  checked={formData.sendEmail}
                  onChange={(e) => {
                    setSendEmail(e.target.checked)
                    setformData({ ...formData, sendEmail: e.target.checked })
                  }}
                />
                <span className="font-medium text-gray-700 text-sm">Send project created email</span>
              </div>

              <div className="flex justify-end gap-5 pb-[20px]">
                <button
                  onClick={handleCloseForm}
                  className="border-[#27004a] bg-white border rounded-md w-20 h-10 text-[#27004a]"
                >
                  Cancel
                </button>
                <button type="submit" className={`allcrm-btn1 ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}>
                  Save
                </button>
              </div>
            </div>
          </form>
        </TabPanel>

        <TabPanel className="m-5">
          <Project_Setting closeform={handleCloseForm} />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default Add_Project

